import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import styles from "./LanguageSwitcher.module.css";

export function LanguageSwitcher() {
	const { i18n, t } = useTranslation();
	const current = i18n.language;

	const toggle = () => {
		const next = current === "tr" ? "en" : "tr";
		i18n.changeLanguage(next);
	};

	return (
		<button
			type="button"
			className={styles.button}
			onClick={toggle}
			title={current === "tr" ? t("languageEn") : t("languageTr")}
		>
			<Globe size={16} />
			<span className={styles.label}>{current === "tr" ? "EN" : "TR"}</span>
		</button>
	);
}
